import React, { Component, useState, useEffect } from 'react';
import {
    Collapse, Container, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink,
    Dropdown, DropdownMenu, DropdownToggle, DropdownItem
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';
import authService from './api-authorization/AuthorizeService'
//import { UserRoles } from './api-authorization/ApiAuthorizationConstants';
import { withTranslation } from 'react-i18next';
import { FaWrench, FaHome, FaCalendarAlt, FaMapMarkerAlt, FaPencilAlt, FaNewspaper} from 'react-icons/fa';

/*export default function useOnScreen(ref) {

    const [isIntersecting, setIntersecting] = useState(false)

    const observer = new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting)
    )

    useEffect(() => {
        observer.observe(ref.current)
        // Remove the observer as soon as the component is unmounted
        return () => { observer.disconnect() }
    }, [])

    return isIntersecting
}*/

class NavMenuPlain extends Component {
    static displayName = NavMenuPlain.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            isAuthenticated: false,
            role: null,
            user: null,
            firstname: null,
            width: window.innerWidth, height: window.innerHeight,
            dropdownOpen: false,
            //document.getElementsByClassName('navbar-toggler-icon')[0].
        };

    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        window.addEventListener('resize', this.updateDimensions);
        this.populateState();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        authService.unsubscribe(this._subscription);
    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([
            authService.isAuthenticated(),
            authService.getUser(),
        ]);
        this.setState({
            isAuthenticated,
            role: user && user.role,
            user: user,
            firstname: user && user.firstname
        });
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    render() {
        //const { t, i18n } = this.props; 
        const { t } = this.props;
        const { collapsed, role } = this.state;
        return (
            <header>
                <Container fluid={true} className='' style={{ backgroundImage: 'url(/images/volunteers-banner-image.jpg)', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
                    <Container style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                        <NavbarBrand tag={Link} to="/"><img src={require('../images/Logo_and_strapline.png')} style={{
                            width: this.state.width > 500 ? '' : (this.state.width - 50) + 'px',
                            paddingTop: this.state.width > 720 ?
                                Math.min(((this.state.width - 720) / 10), 30) + 'px' : '0px',
                            paddingBottom: this.state.width > 720 ?
                                Math.min(((this.state.width - 720) / 10), 40) + 'px' : '0px',
                            paddingLeft: '0px',
                            paddingRight: '0px'
                        }} /></NavbarBrand>
                    </Container>
                </Container>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" dark>
                    <Container>
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row" isOpen={!this.state.collapsed} navbar>
                            <Nav className="navbar-nav mr-auto" > {/*navbar-nav flex-grow*/}
                                <NavItem>
                                    <NavLink tag={Link} className="text-light" to="/"><FaHome className='nav-link-icon' /> Home</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-light" to="/pathmap"><FaMapMarkerAlt className='nav-link-icon' /> Path Map</NavLink>
                                </NavItem>
                                <NavItem>
                                    {this.state.isAuthenticated ? (
                                        <NavLink tag={Link} className="text-light" to="/workprograms/calendar"><FaCalendarAlt className='nav-link-icon' /> {t('Work Programs')}</NavLink>
                                    ) : (
                                        <NavLink tag={Link} className="text-light" to="/publicworkprogramcalendar"><FaCalendarAlt className='nav-link-icon' /> {t('Work Programs')}</NavLink>
                                    )}

                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-light" to="/reportissuemap"><FaPencilAlt className='nav-link-icon' /> {t('Report Issue')}</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-light" to="/newsletters">
                                        <FaNewspaper className='nav-link-icon' /> {t('Newsletter')}
                                    </NavLink>
                                </NavItem>
                                {/*<NavItem>*/}
                                {/*    <NavLink tag={Link} className="text-light" to="/fetch-data">Fetch data </NavLink>*/}
                                {/*</NavItem>*/}
                                {this.state.role && this.state.role.includes("Volunteer") ? (
                                    <div></div>
                                ) : ""}
                                {this.state.role && this.state.role.includes("Volunteer Leader") ? (
                                    <div></div>
                                ) : ""}
                                {this.state.role && this.state.role.includes("Administrator") ? (
                                    <Dropdown className="text-light" nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                                        <DropdownToggle className="text-light" nav caret>
                                            <FaWrench /> Admin
                                        </DropdownToggle>
                                        <DropdownMenu className="text-light">
                                            <DropdownItem>
                                                <NavLink tag={Link} className="text-light" to="/users/activate">{t('User Activation')}</NavLink>
                                            </DropdownItem>
                                            <DropdownItem>
                                                <NavLink tag={Link} className="text-light" to="/users">{t('Users')}</NavLink>
                                            </DropdownItem>
                                            <DropdownItem>
                                                <NavLink tag={Link} className="text-light" to="/workprograms">{t('Work Programs')}</NavLink>
                                            </DropdownItem>
                                            <DropdownItem>
                                                <NavLink tag={Link} className="text-light" to="/volunteergroups">{t('Volunteer Groups')}</NavLink>
                                            </DropdownItem>
                                            <DropdownItem>
                                                <NavLink tag={Link} className="text-light" to="/volunteersections">{t('Volunteer Sections')}</NavLink>
                                            </DropdownItem>
                                            <DropdownItem>
                                                <NavLink tag={Link} className="text-light" to="/paths">{t('Paths')}</NavLink>
                                            </DropdownItem>
                                            <DropdownItem>
                                                <NavLink tag={Link} className="text-light" to="/pathworks">{t('Path Works')}</NavLink>
                                            </DropdownItem>
                                            <DropdownItem>
                                                <NavLink tag={Link} className="text-light" to="/pathstates">{t('Path States')}</NavLink>
                                            </DropdownItem>
                                            <DropdownItem>
                                                <NavLink tag={Link} className="text-light" to="/reportedissues">{t('Reported Issues')}</NavLink>
                                            </DropdownItem>
                                            <DropdownItem>
                                                <NavLink tag={Link} className="text-light" to="/newsletters/list">{t('Newsletters')}</NavLink>
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                ) : null}

                                <LoginMenu>
                                </LoginMenu>
                            </Nav>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }
}
export const NavMenu = withTranslation()(NavMenuPlain);
